export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7316.b8271c21.jpg";